/**
 * handoffMediaPhase — pure derivation of the AI-Voice human-handoff media banner.
 *
 * HONEST media-truth (P0-E): the banner reflects the REAL WebRTC media ladder. "Human Call Active"
 * (green) requires the media path to be connected AND a live remote audio track to be present
 * (`hasLiveAudio`). If the peer is connected but no remote audio track has arrived, we show
 * "Connected — no live audio" (amber) — never a fabricated live state. On hang-up the ladder resolves
 * to "Call Ended" (gray), NOT the amber no-audio badge, while the transcript/summary stay visible.
 *
 * Extracted from UnifiedAgentDesktop so it can be unit-tested without mounting the whole desktop tree.
 */

export const MEDIA_PHASE_UI = {
  media_joining:              { key: 'od.mediaJoining',            tone: 'amber' },
  waiting_for_customer_offer: { key: 'od.waitingForCustomerOffer', tone: 'amber' },
  media_connecting:           { key: 'od.mediaConnecting',         tone: 'amber' },
  human_call_active:          { key: 'od.humanCallActive',         tone: 'green' },
  media_failed:               { key: 'od.mediaFailed',             tone: 'red'   },
  ended:                      { key: 'od.callEnded',               tone: 'gray'  },
};

export const MEDIA_TONE_CLASS = {
  amber: 'bg-amber-50 border-amber-300 text-amber-800',
  green: 'bg-green-50 border-green-300 text-green-800',
  red:   'bg-red-50 border-red-300 text-red-800',
  gray:  'bg-gray-50 border-gray-300 text-gray-700',
};

/**
 * Resolve the banner config for a given media phase + real-audio truth.
 * @param {string} mediaPhase   the WebRTC media ladder phase (idle|media_joining|…|human_call_active|ended|media_failed)
 * @param {boolean} hasLiveAudio  TRUE only when a live REMOTE audio track is actually being received
 * @returns {{key:string, tone:string}|null}
 */
export function resolveHandoffPhaseCfg(mediaPhase, hasLiveAudio) {
  let cfg = MEDIA_PHASE_UI[mediaPhase] || null;
  // Connected/active ladder rung but no real remote audio yet → honest "Connected — no live audio".
  if (mediaPhase === 'human_call_active' && !hasLiveAudio) {
    cfg = { key: 'od.connectedNoAudio', tone: 'amber' };
  }
  return cfg;
}
